const baseURL = "/r/";

export const indexRoute = baseURL;
export const previewRoute = `${baseURL}preview/:mainGroup/:id`;
export const albumIndexRoute = `${baseURL}album`;
export const albumNameRoute = `${baseURL}album/:albumId`;
export const settingsRoute = `${baseURL}settings`;
export const registrationRoute = `${baseURL}registration`;
export const needActivationRoute = `${baseURL}need-activation`;
